import { useEffect, useState } from "react";
import api from "../api/client";
import { useToast } from "../store/toast";
import { abrirPdfEnNuevaPestana, fmtStampFull } from "../utils";

export default function ConstanciaHistorial({ projectId, taskId, refreshKey }) {
  const { push } = useToast();
  const [filas, setFilas] = useState([]);
  const [reenviandoId, setReenviandoId] = useState(null);

  const cargar = () => api.get(`/projects/${projectId}/constancias`)
    .then((r) => setFilas(r.data.filter((f) => f.checklist_task_id === taskId)))
    .catch(() => setFilas([]));
  useEffect(() => { cargar(); }, [projectId, taskId, refreshKey]);

  if (filas.length === 0) return null;

  const reenviar = async (id) => {
    setReenviandoId(id);
    try {
      await api.post(`/constancias/${id}/reenviar`, {});
      push("Constancia reenviada", "success");
      cargar();
    } catch (err) {
      push(err.response?.data?.detail || "No se pudo reenviar", "error");
    } finally {
      setReenviandoId(null);
    }
  };

  const descargar = (id) => abrirPdfEnNuevaPestana(
    async () => (await api.get(`/constancias/${id}/pdf`, { responseType: "blob" })).data,
    { onError: () => push("No se pudo descargar el PDF", "error") },
  );

  return (
    <div className="mt-3">
      <div className="label">Constancias emitidas ({filas.length})</div>
      <div className="overflow-x-auto rounded-lg border border-slate-200">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-[11px] uppercase text-slate-500">
            <tr>
              <th className="px-2 py-1 text-left">Fecha</th>
              <th className="px-2 py-1 text-left">Destinatario</th>
              <th className="px-2 py-1 text-left">Emisor</th>
              <th className="px-2 py-1" />
            </tr>
          </thead>
          <tbody>
            {filas.map((f) => (
              <tr key={f.id} className="border-t border-slate-100">
                <td className="px-2 py-1 text-slate-500">{fmtStampFull(f.created_at)}</td>
                <td className="px-2 py-1">{f.destinatarios.map((d) => d.email).join(", ")}</td>
                <td className="px-2 py-1 text-slate-500">{f.emisor}</td>
                <td className="px-2 py-1 text-right">
                  <button type="button" className="btn-ghost px-2 py-0.5 text-xs" onClick={() => descargar(f.id)}>Descargar</button>
                  <button type="button" className="btn-ghost px-2 py-0.5 text-xs" disabled={reenviandoId === f.id}
                    onClick={() => reenviar(f.id)}>
                    {reenviandoId === f.id ? "Reenviando…" : "Reenviar"}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
